import axios from "axios";
import { api } from "../config";
// MEASUREMENT ONLY - Task 24731. Silent unless localStorage.apiTiming === "1".
import { parseServerTiming, recordTiming } from "./APIdata/apiTiming";

// default
axios.defaults.baseURL = api.API_URL;
// content type
axios.defaults.headers.post["Content-Type"] = "application/json";
//add axios cross domain request support for all browsers cors access-contrl-allow-origin *
axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
// no caching enabled -> might be performance costly think on alternatives later TODO: create non cached version and Cached version for data that dont change on request
axios.defaults.headers.common["Cache-Control"] = "no-cache";

// content type
const token = JSON.parse(sessionStorage.getItem("token"))
  ? JSON.parse(sessionStorage.getItem("token")).token
  : null;
if (token) axios.defaults.headers.common["Authorization"] = "Bearer " + token;

// MEASUREMENT ONLY - Task 24731. Stamps the request start so the response
// interceptor below can work out the perceived round trip.
axios.interceptors.request.use(function (config) {
  try {
    config.metadata = {
      start:
        typeof performance !== "undefined" ? performance.now() : Date.now(),
    };
  } catch (_) {
    // never let instrumentation break a request
  }
  return config;
});

// intercepting to capture errors
axios.interceptors.response.use(
  function (response) {
    // MEASUREMENT ONLY - Task 24731. Must run before the strip below, because
    // returning response.data throws away the headers we need.
    try {
      const end =
        typeof performance !== "undefined" ? performance.now() : Date.now();
      const start = response?.config?.metadata?.start;
      if (typeof start === "number") {
        recordTiming({
          url: response?.config?.url,
          method: (response?.config?.method || "get").toUpperCase(),
          status: response?.status,
          perceivedMs: end - start,
          server: parseServerTiming(response?.headers?.["server-timing"]),
        });
      }
    } catch (_) {
      // never let instrumentation break a request
    }

    return response.data ? response.data : response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    let message;
    switch (error.status) {
      case 500:
        message = "Internal Server Error";
        break;
      case 401:
        message = "Invalid credentials";
        break;
      case 404:
        message = "Sorry! the data you are looking for could not be found";
        break;
      default:
        message = error.message || error;
    }
    return Promise.reject(message);
  }
);
/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token) => {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
};

class APIClient {
  /**
   * Fetches data from given url
   */

  //  get = (url, params) => {
  //   return axios.get(url, params);
  // };
  get = (url, params) => {
    let response;

    let paramKeys = [];

    if (params) {
      Object.keys(params).map((key) => {
        paramKeys.push(key + "=" + params[key]);
        return paramKeys;
      });

      const queryString =
        paramKeys && paramKeys.length ? paramKeys.join("&") : "";
      response = axios.get(`${url}?${queryString}`, params);
    } else {
      response = axios.get(`${url}`, params);
    }

    return response;
  };
  /**
   * post given data to url
   */
  create = (url, data) => {
    return axios.post(url, data);
  };

  /**
   * Updates data
   */
  update = (url, data) => {
    return axios.patch(url, data);
  };

  put = (url, data) => {
    return axios.put(url, data);
  };
  /**
   * Delete
   */
  delete = (url, config) => {
    return axios.delete(url, { ...config });
  };
}
const getLoggedinUser = () => {
  const user = localStorage.getItem("authUser");
  if (!user) {
    return null;
  } else {
    //check if user is valid for parsing json
    if (!user.startsWith("{") && !user.endsWith("}")) return null;
    return JSON?.parse(user);
  }
};

export { APIClient, setAuthorization, getLoggedinUser };
